import { useState } from 'react';
import { useModal } from '@stores';
import { Button } from '@trussworks/react-uswds';

// deprecated?
const DeleteButton = ({ deleteText, handleDelete, customClosingLogic }) => {
  const { closeSecondaryModal } = useModal();
  const [isConfirming, setIsConfirming] = useState(false);

  const onDelete = (e) => {
    setIsConfirming(false);
    handleDelete(e);
    if (!customClosingLogic) closeSecondaryModal();
  };

  return isConfirming ? (
    <>
      <Button secondary onClick={onDelete}>
        Confirm
      </Button>
      <Button onClick={() => setIsConfirming(false)}>Cancel</Button>
    </>
  ) : (
    <Button secondary onClick={() => setIsConfirming(true)}>
      {deleteText}
    </Button>
  );
};

export default DeleteButton;
